// Compare modal state
import PatcraftApi from "../../../scripts/patcraft-api";

// Initial state
const state = () => ({
  open: false,
  showCompareContent: false,
  showPdfPopup: false
});

// Getters
const getters = {
  open: (state, getters, rootState) => {
    return state.open;
  },
  showCompareContent: (state, getters, rootState) => {
    return state.showCompareContent;
  },
  getShowPdfPopup: (state) => {
    return state.showPdfPopup;
  }
};

// Actions
const actions = {
  open({ commit, state }) {
    commit("setCompareModal", true);
  },
  close({ commit, state }) {
    commit("setCompareModal", false);
  },
  showCompareContent({ commit},payload) {
    commit("setCompareContent", payload);
    return payload
  },
  showPdfPopup({ commit }) {
    commit("setShowPdfPopup");
  },
  updateCartCountInHeader({ commit, state }, totalCount) {
    let type = 1;
    let cartCountElement = document.getElementsByClassName(
      "nav-top-customer-link-with-number-indicator"
    )[0];
    if (!cartCountElement) {
      type = 0;
      cartCountElement = document.getElementsByClassName(
        "nav-top-customer-link-with-number-indicator-empty"
      )[0];
    }

    if (!type) {
      cartCountElement.classList.add(
        "nav-top-customer-link-with-number-indicator"
      );
      cartCountElement.classList.remove(
        "nav-top-customer-link-with-number-indicator-empty"
      );
    }
    cartCountElement.innerHTML = cartCountElement
      ? parseInt(cartCountElement.innerHTML) + totalCount
      : totalCount;
  },
  addCompareToBasket({ commit, dispatch, state }, items) {
    PatcraftApi.addMultipleItemsBasket(items)
      .then(res => {
        dispatch("updateCartCountInHeader", res.data.length);
        dispatch(
          "notifications/add",
          {
            type: "success",
            title: "Basket updated",
            description: `${res.data.length} Products added to your cart.`
          },
          { root: true }
        );
        if (res && res.data && res.data.find(i => i.error))
          dispatch(
            "notifications/add",
            {
              type: "warning",
              title: "Basket updated",
              description: res.data.find(i => i.error).error
            },
            { root: true }
          );
      })
      .catch(function(error) {
        console.log(error);
        dispatch(
          "notifications/add",
          {
            type: "error",
            title: "Error",
            description:
              "An error occurred when adding the product to your cart."
          },
          { root: true }
        );
      });
  }
};

// Mutations
const mutations = {
  setCompareModal(state, open) {
    state.open = open;
  },
  setCompareContent(state, data) {
    state.showCompareContent = data;
  },
  setShowPdfPopup(state) {
    state.showPdfPopup = true;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
